import React from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

const TermsConditions = React.forwardRef((props, ref) => {
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Terms and Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                {/* <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col> */}
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">TC</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Terms and Conditions</span>
                  <span className="subHeaderTitle">Terms and Conditions
                  </span>
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">

                <div
                  style={{
                    maxHeight: "60vh",
                    overflowY: "auto",
                    whiteSpace: "pre-wrap",
                    padding: "1rem",
                    fontSize: "0.95rem",
                    lineHeight: "1.6",
                  }}
                >
                  {`1. This Equipment Rental Agreement is made between Bio-medical Instruments, Inc. and “Renter” and states the agreement of the parties as follows:

2. EQUIPMENT SUBJECT TO RENTAL. The Renter agrees to rent the equipment listed on the attached Exhibit “A”.

3. PAYMENT TERMS. The Renter shall make a one time deposit of the amount noted in the rental summary box label “Down Payment”. The amount covers the first and last month’s payments.
The Renter must provide a valid charge card to be held on file. Bio-Medical Instruments will automatically charge the card on the payment date as noted in the rental summary box labeled “Recurring Payment Day of Month” each month for the monthly payment amount.

4. NON-SUFFICIENT FUNDS & SERVICE CHARGE. If a charge is returned to Bio-Medical Instruments for lack of sufficient funds you will be charged a service fee of $35.

5. RENTAL TERM. This Rental Agreement shall begin on the above start date. The rental term has a minimum of 4 months but may continue as long as the renter desires and meets the requirements of the agreement. The return date is 4 months after the start date plus a 14 days grace period.
In order to end the rental term the renter must first notify Bio-medical Instruments 30 days before returning the equipment. The notice must be in writing via email, fax or letter.
The equipment must be returned in full as specified in exhibit A.
To avoid additional monthly charges the equipment must be returned within 14 days after the Recurring Payment Day of Month (example: Recurring payment date = 10th of month - the equipment must be received in hand by Bio-medical Instruments by 24th of the month). This provides the renter with a 14 day grace period in which to ship the equipment back to Bio-medical Instruments.

6. RETURN OF EQUIPMENT. The equipment must be returned via trackable service and it is recommended that the renter insure the return package for the full value of the equipment in the event of loss or damage.

7. CARE AND OPERATION OF THE EQUIPMENT. The equipment may only be used and operated in a careful manner. Its use must comply with all laws, ordinances, and regulations relating to the possession, use, maintenance of the equipment, including registration and/or licensing requirements, if any.

8. ALTERATIONS. Renter may not make any alterations to the equipment without prior written consent from Bio-medical Instruments.

9. MAINTENANCE AND REPAIR. The Renter shall maintain the equipment in good repair and operating condition, allowing for reasonable wear and tear. Any damage deemed outside of normal wear and tear that requires repair will be the responsibility of the renter. Costs associated with the repair(s) will be charged to the credit card held on file.
The Renter may NOT attempt to repair the equipment or have the equipment repaired. All repairs must be handled directly with Bio-medical Instruments.

10. CERTIFICATION. Renter certifies that the application, statements, trade references, and financial reports submitted to Bio-Medical Instruments are true and correct and any material misrepresentation will constitute a default under this Rental Agreement.

11. ARBITRATION. Any controversy or claim relating to this agreement, including the construction or application of this agreement, will be settled by binding arbitration under the rules of the American Arbitration Association, and any judgment granted by the arbitrator(s) may be enforced in any court of proper jurisdiction.

12. ACCEPTANCE OF EQUIPMENT. The Renter shall inspect each item of equipment delivered pursuant to this Rental Agreement. The Renter shall immediately notify Bio-Medical Instruments of any discrepancies between such item of equipment and the description on equipment in the Equipment Schedule. If the Renter fails to provide such notice in writing within 2 days after the delivery of the equipment, the Renter will be conclusively presumed to have accepted the equipment as specified in the Equipment Schedule.

13. WARRANTY. Bio-Medical Instruments warrants the above property is in good working condition, but makes no further warranties, express or implied.

14. RISK OF LOSS OR DAMAGE. The Renter assumes all risks of loss or damage to the equipment from any cause, and agrees to return the equipment to a state of good working order, or replace the equipment with like equipment in good working order, which equipment shall become the property of Bio-Medical Instruments and subject to this agreement.

15. LIABILITY AND INDEMNITY. Liability for injury, disability, and death of workers and other persons caused by operating, handling, or transporting the equipment during the term of this agreement is the obligation of the Renter, and the Renter shall indemnify and hold Bio-Medical Instruments harmless from and against all such liability.

16. DEFAULT. The occurrence of any of the following shall constitute a default under this Rental Agreement:
A. The failure to make a required payment under this Rental Agreement when due.
B. The violation of any provision or requirement that is not corrected within 15 days after written notice of the violation is given.
C. The insolvency or bankruptcy of the Renter.
D. The subjection of any of Renter’s property to any levy, seizure, assignment, application or sale for or by any credit or government agency.

17. RIGHTS ON DEFAULT. In addition to any other rights afforded Bio-Medical Instruments by law, if the Renter is in default under this Rental Agreement, without notice to or demand on the Renter, Bio-Medical Instruments may take possession of the equipment as provided by law, deduct the costs of recovery (including attorney fees and legal costs), repair, and related costs, and hold the Renter responsible for any deficiency. The rights and remedies of Bio-Medical Instruments provided by law and this Agreement shall be cumulative in nature. Bio-Medical Instruments shall be obligated to re-rent the equipment, or otherwise mitigate the damages from the default, only as required by law.

18. NOTICE. All notices required or permitted under this Rental Agreement shall be deemed delivered when delivered in person or by mail, postage prepaid, addressed to the appropriate party at the address shown for that party at the beginning of this agreement.

19. ENTIRE AGREEMENT AND MODIFICATION. This Rental Agreement constitutes the entire agreement between the parties. No modification of this agreement shall be effective unless in writing and signed by both parties. This Rental Agreement replaces any and all prior agreements between the parties.

20. GOVERNING PARTIES. This Rental Agreement shall be construed in accordance with the laws of the State of Michigan.

21. SEVERABILITY. If any portion of this Rental Agreement shall be held to be invalid or unenforceable for any reason, the remaining provisions shall continue to be valid and enforceable. If a court finds that any provision of this Rental Agreement is invalid or unenforceable, but that by limiting such provision, it would become valid and enforceable, then such provision shall be deemed to be written, construed, and enforced as so limited.

22. AGREEMENT. Applicant agrees to pay any costs incurred to collect an account balance, including court costs, collection fees and attorney’s fees of not less than 35% of the unpaid principal, plus interest and that all matters related to purchase or performance shall be construed, interpreted, applied, and governed in all respects by laws of the State of Michigan U.S.A. and that if court action is required all proceedings will take place in Clinton Township, Michigan U.S.A.`}
                </div>


              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">

            </div>

          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default TermsConditions;
